import * as types from "./types";
import jsonHelper from "../../shared/jsonHelper";

const mutations = {
  [types.CHANGE_PROPERTY](state, payload) {
    jsonHelper.setProperty(state.projects, payload.path, payload.value);
  },
  [types.CLEAR](state) {
    state.recentProjects = {};
    state.projects = {};
  },
  [types.LOAD](state, payload) {
    if (payload != null) {
      if (payload.projectId != null) {
        state.projects = {};

        state.projects[payload.projectId] = payload.project;
        state.currentProject = payload.projectId;

        let recent = {};
        recent.modality = payload.project.modality;
        recent.projectId = payload.project.projectId;
        recent.name = payload.project.name;
        state.recentProjects = {};
        state.recentProjects[payload.projectId] = recent;
      }
    }
  },
  [types.REMOVE](state, prjID) {
    if (state.currentProject == prjID) {
      state.currentProject = "";
    }
    //delete state.projects[prjId];
    delete state.recentProjects[prjID];
  },
  [types.UPDATE](state, payload) {
    jsonHelper.setProperty(state.projects, `${payload.path}.input`, payload.unidato.input);
    jsonHelper.setProperty(state.projects, `${payload.path}.output`, payload.unidato.output);
    jsonHelper.setProperty(
      state.projects,
      `${payload.path}.outputBilancio`,
      payload.unidato.outputBilancio
    );
    jsonHelper.setProperty(
      state.projects,
      `${payload.path}.userInputValueDbl`,
      payload.unidato.input.usrValue.value
    );
  },
  [types.SET_TYPE_PIASTRA](state, payload) {
    state.isSaldobrasata = payload;
  },
  [types.SET_VERIFICA](state, payload) {
    state.isVerifica = payload;
  },
  [types.SET_SELEZIONE](state, payload) {
    state.isSelezione = payload;
  },
  [types.SET_RESULTS](state, payload) {
    state.selectionOutput = payload;
  },
  [types.SET_SELECTION_RESULTS](state, payload) {
    state.selectionResults = payload;
  },
  [types.SET_DEFAULT_VALUES](state, payload) {
    state.defValues = payload;
  },
  [types.SET_BLOCCO_CALCOLO](state, payload) {
    state.bloccaCalcolo = payload;
  }
};

export default mutations;
